import 'core-js/fn/symbol/iterator.js'
import 'core-js/es6/symbol.js'
import 'core-js/fn/array/find'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/find-index'
import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import {Normalize} from 'styled-normalize'
import ReactGA from 'react-ga'

import {App} from './js/App'
import {GlobalStyle} from './js/common/StyledComponents'
import * as serviceWorker from './serviceWorker'
import Settings from './Settings'

const Main = () => {
  return (
    <div>
      <GlobalStyle />
      <Normalize />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </div>
  )
}

ReactGA.initialize(Settings.analyticsCode)
ReactDOM.render(<Main />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
